import React, { Component } from "react";
import { PropTypes } from "prop-types";
import PlacementSelector from "@zendesk/knowledge-components/lib/PlacementSelector";
import {
  Modal,
  Header,
  Body,
  Footer,
  Close,
} from "@zendeskgarden/react-modals";
import t from "@zendesk/client-i18n-tools";
import Gap from "@zendesk/knowledge-components/lib/Gap";
import { Button } from "@zendeskgarden/react-buttons";
import styles from "./index.css";

export default class MoveToModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: {
        type: undefined,
        id: null,
      },
    };

    this.onOptionSelect = this.onOptionSelect.bind(this);
  }

  onOptionSelect() {
    const { onMove } = this.props;
    const { selectedOption } = this.state;
    onMove(selectedOption);
  }

  onSectionClick = option => {
    this.setState({ selectedOption: option });
  };

  render() {
    const { onClose, name, destinationTypes } = this.props;
    const { selectedOption } = this.state;

    const isButtonDisabled =
      !selectedOption.id || !destinationTypes.includes(selectedOption.type);

    return (
      <Modal onClose={onClose}>
        <Header>{t("knowledge-arrange.moveTo_move")}</Header>
        <Body>
          <div className={styles.body}>
            <p className={styles.description}>
              {t.format("knowledge-arrange.moveTo.selectDestination", {
                name: () => (
                  <strong
                    key="item-name"
                    className={styles.name}
                  >{`"${name}"`}</strong>
                ),
              })}
            </p>
            <PlacementSelector onOptionSelect={this.onSectionClick} />
          </div>
        </Body>
        <Footer>
          <Button onClick={onClose}>
            {t("knowledge-arrange.moveTo_cancel")}
          </Button>
          <Gap.Medium />
          <Button
            primary
            disabled={isButtonDisabled}
            onClick={this.onOptionSelect}
          >
            {t("knowledge-arrange.moveTo_move")}
          </Button>
        </Footer>
        <Close aria-label="Close modal" />
      </Modal>
    );
  }
}

MoveToModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onMove: PropTypes.func,
  name: PropTypes.string,
  destinationTypes: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/MoveToModal/index.js